import { appLocalStorage } from "../app-storage/app-storage";

export type Theme = "light" | "dark" | "default"

class ThemeService {
  constructor() {
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", e => {
      if (this.getSelectedTheme() === "default") {
        this.updateTheme();
      }
    });
  }

  getSelectedTheme(): Theme {
    return appLocalStorage.getItem("theme") || "default";
  }

  setSelectedTheme(theme: Theme | null) {
    appLocalStorage.setItem("theme", theme);
  }

  private getBrowserDefaultTheme(): Theme {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }

  updateTheme() {
    let theme = this.getSelectedTheme();
    if (theme === "default") {
      theme = this.getBrowserDefaultTheme()
    }

    if (theme === "dark") {
      document.documentElement.setAttribute("data-theme", theme);
    } else if (theme === "light") {
      document.documentElement.removeAttribute("data-theme");
    }
  }
}

export const themeService = new ThemeService();